// extracted by mini-css-extract-plugin
export default {"root":"PropertyView_root__BLMGt","header":"PropertyView_header__c8c2f","close":"PropertyView_close__3sjrM","body":"PropertyView_body__tFSXL"};